// TODO: This list is currently static based on a spreadsheet, but in the near future we
// would want to make it dynamic based on server data.
//
// https://docs.google.com/spreadsheets/d/1D2-Do4_-4uKgwHHmiJ4CYdPLao666x7ikJ452pJLbdo
//
export default {
  'Art': [
    'Acting',
    'Art History',
    'Dance',
    'Drawing',
    'Filmmaking',
    'Music',
    'Painting',
    'Photography'
  ],
  'English': [
    'Creative Writing',
    'Literature',
    'Reading',
    'Writing',
    'Phonics',
    'Public Speaking',
    'Spelling',
    'Vocabulary'
  ],
  'Enrichment': [
    'After School',
    'Cooking',
    'Personal Finance',
    'Social Skills',
    'Logic Building',
    'Study Skills and Organization',
    'Games',
    'Fitness'
  ],
  'Languages': [
    'Spanish',
    'German',
    'English Language',
    'French',
    'Chinese',
    'Japanese',
    'Latin',
    'Sign Language'
  ],
  'Math': [
    'Multiplication',
    'Numbers',
    'Algebra',
    'Fractions',
    'Calculus',
    'Puzzles',
    'Geometry',
    'Statistics'
  ],
  'Technology and Coding': [
    'Animation',
    'Python',
    'Machine Learning',
    'Databases',
    'Game Design',
    'Computer Hardware',
    'Robotics',
    'Coding',
    'Web Development',
    'Video Editing'
  ],
  'Science': [
    'Health',
    'Biology',
    'Chemistry',
    'Earth Sciences',
    'Physics',
    'Astronomy',
    'Zoology',
    'Social Sciences'
  ],
  'Social Studies': [
    'American History',
    'Geography',
    'World History',
    'Government',
    'Mythology'
  ],
  'Test Prep': [
    'SAT',
    'ACT',
    'PSAT',
    'AP',
    'College Admission',
    'GMAT',
    'LSAT',
    'GRE',
    'ISEE',
    'SSAT'
  ],
  'Professional Certifications': [
    'CPA',
    'Series 7',
    'Series 65',
    'NCLEX',
    'PMP',
    'Praxis',
    'SIE'
  ]
};
